import { Grid, Tooltip, Typography } from "@mui/material";
import { BiMinus, BiPlus } from "react-icons/bi";
import ClearIcon from "@mui/icons-material/Clear";
import ImgContainer from "components/shared/Image";
import {
  AddProductWrapper,
  IconWrapper,
  StyledDeleteDiv,
  StyledImageDiv,
  StyledInput,
  StyledMainDivCount,
  StyledMainDivFlex,
  StyledMainDivImageAndInfo,
  StyledMainPaper,
  StyledProductInfoDiv,
  StyledProductPrice,
  StyledProductTitle,
  StyledProductTitleColor,
} from "./Card.style";
import spliter from "helper/digit-spliter";
import { ImInfinite } from "react-icons/im";
import { MdDelete } from "react-icons/md";
import LoadingPartCM from "components/shared/PartLoading";

export default function ProductCard(props) {
  const product = props.items;
  const isLimited = product.type === "limited";
  const hasDiscount = product.discount_percentage > 0;

  return (
    <>
      <Grid item lg={6} md={6} sm={12} xs={12} style={{ padding: "10px" }}>
        <StyledMainPaper elevation={3}>
          <StyledDeleteDiv onClick={() => props.onDelete(product.id)}>
            <ClearIcon />
          </StyledDeleteDiv>
          <StyledMainDivFlex>
            <StyledMainDivImageAndInfo>
              <StyledImageDiv>
                <ImgContainer
                  isWeb
                  src={product.image}
                  alt={product.title}
                  objectFit="contain"
                  width="100%"
                  height="100%"
                />
              </StyledImageDiv>

              <StyledProductInfoDiv>
                <StyledProductTitle>{product.title}</StyledProductTitle>
                <StyledProductTitleColor>
                  <span> رنگ : </span>
                  <span style={{ background: product.color }}></span>
                </StyledProductTitleColor>
                <StyledProductPrice>
                  {spliter(+product?.price * +props.items?.quantity)} تومان
                </StyledProductPrice>
              </StyledProductInfoDiv>
            </StyledMainDivImageAndInfo>

            <StyledMainDivCount>
              {props.LoadingPart == true ? (
                <div style={{ textAlign: "center" }}>
                  <LoadingPartCM />
                </div>
              ) : (
                <AddProductWrapper sx={{ mr: { sm: 2, xs: 3 } }}>
                  <IconWrapper
                    onClick={() => props.onSubmit(props.items?.id, "increase")}
                  >
                    <BiPlus />
                  </IconWrapper>
                  <StyledInput
                    variant="filled"
                    defaultValue={product?.quantity}
                    {...props.register(`product${props.items?.id}`)}
                    inputProps={{ readOnly: true }}
                  />
                  <IconWrapper
                    onClick={() => props.onSubmit(props.items?.id, "decrease")}
                  >
                    <BiMinus />
                  </IconWrapper>
                </AddProductWrapper>
              )}
            </StyledMainDivCount>
          </StyledMainDivFlex>
        </StyledMainPaper>
      </Grid>
    </>
  );
}
